// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IBalanceTierDto } from './IBalanceTierDto';
import {
    IBalanceTierDtoFromJSON,
    IBalanceTierDtoFromJSONTyped,
    IBalanceTierDtoToJSON,
    IBalanceTierDtoToJSONTyped,
} from './IBalanceTierDto';

/**
 * 
 * @export
 * @interface IVersionDto
 */
export interface IVersionDto {
    /**
     * 
     * @type {number}
     * @memberof IVersionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IVersionDto
     */
    natural_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IVersionDto
     */
    previous_version_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IVersionDto
     */
    template_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IVersionDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IVersionDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IVersionDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IVersionDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {Array<IBalanceTierDto>}
     * @memberof IVersionDto
     */
    balance_tier?: Array<IBalanceTierDto>;
}

/**
 * Check if a given object implements the IVersionDto interface.
 */
export function instanceOfIVersionDto(value: object): value is IVersionDto {
    return true;
}

export function IVersionDtoFromJSON(json: any): IVersionDto {
    return IVersionDtoFromJSONTyped(json, false);
}

export function IVersionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVersionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'natural_id': json['natural_id'] == null ? undefined : json['natural_id'],
        'previous_version_id': json['previous_version_id'] == null ? undefined : json['previous_version_id'],
        'template_id': json['template_id'] == null ? undefined : json['template_id'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'balance_tier': json['balance_tier'] == null ? undefined : ((json['balance_tier'] as Array<any>).map(IBalanceTierDtoFromJSON)),
    };
}

export function IVersionDtoToJSON(json: any): IVersionDto {
    return IVersionDtoToJSONTyped(json, false);
}

export function IVersionDtoToJSONTyped(value?: IVersionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'natural_id': value['natural_id'],
        'previous_version_id': value['previous_version_id'],
        'template_id': value['template_id'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'balance_tier': value['balance_tier'] == null ? undefined : ((value['balance_tier'] as Array<any>).map(IBalanceTierDtoToJSON)),
    };
}

